import React from "react";

const Field = (props) => {
  return (
    <div className={"field"}>
      {props.children}
    </div>
  )
}

export default Field
